import React, { useState } from 'react';
import { connect } from 'react-redux';

const hideShowContent = event => {
  event.preventDefault();
  const contentShowHide = document.querySelector('.showLessMoreContent');
  const hiddenItems = Array.prototype.slice.call(
    document.querySelectorAll('.contentHide')
  );

  const showing = contentShowHide.textContent === 'Show more';

  hiddenItems.forEach(function (item) {
    if (!showing) {
      item.classList.add('content-hidden');
    } else {
      item.classList.remove('content-hidden');
    }

    contentShowHide.textContent =
      contentShowHide.textContent === 'Show more' ? 'Show Less' : 'Show more';
  });
};

const AboutVendor = props => {
  const [isShowMore, setShowMore] = useState(false);
  return (
    <React.Fragment>
      <h1>{`About ${props.vendorName}`}</h1>
      {/* <div className="content">
        {!isShowMore ? <span className="content_blur"></span> : null}
        <span className={!isShowMore ? 'content_open' : null}>
          {`${props.vendorDescription.slice(0, 331)}`}
        </span>
        <span className="item content-hidden contentHide">
          {`${props.vendorDescription.slice(331)}`}
        </span>
        <a
          href="#show more"
          className="showLessMoreContent"
          onClick={e => {
            hideShowContent(e);
            setShowMore(!isShowMore);
          }}
        >
          Show more
        </a>
      </div> */}
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    vendorDescription: state.vendorProfile.description,
    vendorName: state.vendorCommon.name,
  };
};

export default connect(mapStateToProps)(AboutVendor);
